import React from 'react';
import { Palette, Grid, CreditCard, Layers } from 'lucide-react';

/**
 * Компонент для выбора материалов отделки
 */
const MaterialsSection = ({ 
  formData, 
  handleInputChange, 
  errors,
  flooringTypes,
  wallMaterialTypes,
  ceilingTypes
}) => {
  return (
    <div className="mb-6 bg-gray-50 dark:bg-gray-800/30 p-4 rounded-lg border border-gray-200 dark:border-gray-700">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Palette className="w-5 h-5 mr-2 text-fuchsia-500" />
        Материалы для отделки
      </h3>
      
      <div className="grid grid-cols-1 gap-6">
        {/* Напольное покрытие */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div className="sm:col-span-2 border-b pb-2 border-gray-200 dark:border-gray-700 mb-2">
            <h4 className="text-sm font-medium text-gray-800 dark:text-gray-200 flex items-center gap-2">
              <Grid className="w-4 h-4 text-fuchsia-500" />
              Напольное покрытие
            </h4>
          </div>
          
          <div>
            <label htmlFor="flooringType" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              Тип напольного покрытия
            </label>
            <select
              id="flooringType"
              name="flooringType"
              value={formData.flooringType}
              onChange={handleInputChange}
              className="form-select w-full"
            >
              {flooringTypes.map((type) => (
                <option key={type.id} value={type.id}>
                  {type.name}
                </option>
              ))}
            </select>
          </div>
          
          <div>
            <label htmlFor="flooringUnitCost" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
              <CreditCard className="w-4 h-4 mr-1 text-fuchsia-500" />
              Стоимость (₽/м²)
            </label>
            <input
              type="text"
              id="flooringUnitCost"
              name="flooringUnitCost"
              value={formData.flooringUnitCost}
              onChange={handleInputChange}
              className={`form-input w-full ${errors.flooringUnitCost ? 'input-error' : ''}`}
              placeholder="Стоимость за м²"
            />
            {errors.flooringUnitCost && (
              <p className="mt-1 text-xs text-red-500 dark:text-red-400">
                {errors.flooringUnitCost}
              </p>
            )}
          </div>
        </div>
        
        {/* Материал стен */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div className="sm:col-span-2 border-b pb-2 border-gray-200 dark:border-gray-700 mb-2">
            <h4 className="text-sm font-medium text-gray-800 dark:text-gray-200 flex items-center gap-2">
              <Layers className="w-4 h-4 text-fuchsia-500" />
              Отделка стен
            </h4>
          </div>
          
          <div>
            <label htmlFor="wallMaterialType" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              Тип отделки стен
            </label>
            <select
              id="wallMaterialType"
              name="wallMaterialType"
              value={formData.wallMaterialType}
              onChange={handleInputChange}
              className="form-select w-full"
            >
              {wallMaterialTypes.map((type) => (
                <option key={type.id} value={type.id}>
                  {type.name}
                </option>
              ))}
            </select>
          </div>
          
          <div>
            <label htmlFor="wallMaterialUnitCost" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
              <CreditCard className="w-4 h-4 mr-1 text-fuchsia-500" />
              Стоимость (₽/м²)
            </label>
            <input
              type="text"
              id="wallMaterialUnitCost"
              name="wallMaterialUnitCost"
              value={formData.wallMaterialUnitCost}
              onChange={handleInputChange}
              className={`form-input w-full ${errors.wallMaterialUnitCost ? 'input-error' : ''}`}
              placeholder="Стоимость за м²"
            />
            {errors.wallMaterialUnitCost && (
              <p className="mt-1 text-xs text-red-500 dark:text-red-400">
                {errors.wallMaterialUnitCost}
              </p>
            )}
          </div>
        </div>
        
        {/* Материал потолка */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div className="sm:col-span-2 border-b pb-2 border-gray-200 dark:border-gray-700 mb-2">
            <h4 className="text-sm font-medium text-gray-800 dark:text-gray-200 flex items-center gap-2">
              <Layers className="w-4 h-4 text-fuchsia-500" />
              Отделка потолка
            </h4>
          </div>
          
          <div>
            <label htmlFor="ceilingType" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              Тип отделки потолка
            </label>
            <select
              id="ceilingType"
              name="ceilingType"
              value={formData.ceilingType}
              onChange={handleInputChange}
              className="form-select w-full"
            >
              {ceilingTypes.map((type) => (
                <option key={type.id} value={type.id}>
                  {type.name}
                </option>
              ))}
            </select>
          </div>
          
          <div>
            <label htmlFor="ceilingUnitCost" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
              <CreditCard className="w-4 h-4 mr-1 text-fuchsia-500" />
              Стоимость (₽/м²)
            </label>
            <input
              type="text"
              id="ceilingUnitCost"
              name="ceilingUnitCost"
              value={formData.ceilingUnitCost}
              onChange={handleInputChange}
              className={`form-input w-full ${errors.ceilingUnitCost ? 'input-error' : ''}`}
              placeholder="Стоимость за м²"
            />
            {errors.ceilingUnitCost && (
              <p className="mt-1 text-xs text-red-500 dark:text-red-400">
                {errors.ceilingUnitCost}
              </p>
            )}
          </div>
        </div>
      </div>
      
      <div className="mt-4 p-3 bg-fuchsia-50 dark:bg-fuchsia-900/20 rounded-lg border border-fuchsia-100 dark:border-fuchsia-800">
        <p className="text-sm text-fuchsia-700 dark:text-fuchsia-300">
          <span className="font-semibold">Совет:</span> Указанные стоимости материалов являются приблизительными. Для более точного расчета 
          рекомендуется уточнять актуальные цены у поставщиков. Вы можете выбрать тип материала, и стоимость будет автоматически заполнена 
          средними ценами по России на текущий момент. Вы также можете изменить цену вручную.
        </p>
      </div>
    </div>
  );
};

export default MaterialsSection;